import { invoicePaymentLabel } from "./invoiceDueDate";
export const INVOICE_STATUS_FILTERS = [
  { value: "all", label: "Toutes" },
  { value: "a_regler", label: "À régler" },
  { value: "payee", label: "Payée" },
  { value: "impayee", label: "Impayée" },
  { value: "partielle", label: "Partielle" },
];

const settlement = (invoice) =>
  String(invoice?.FactureRegle || "")
    .trim()
    .toUpperCase();

export function invoiceMatchesStatus(invoice, status) {
  if (!status || status === "all") return true;
  const value = settlement(invoice);
  const label = invoicePaymentLabel({...invoice,FactureRegle:value});
  const labels = {payee:"Payée",partielle:"Partielle",impayee:"Impayée",a_regler:"À régler"};
  return labels[status] ? label === labels[status] : true;
}
